export default "__VITE_ASSET__CI1rG_zZ__"